// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"703":"088fabf9","873":"79308272"}[chunkId] + ".css";
};